var React = require('react');

function BgSection5 (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("path",{"d":"M490.54 398.78a534.4 534.4 0 01-111.47-282.35h-.06a127.5 127.5 0 00-229.34-65l-.09-.12A464.74 464.74 0 010 181.18V454.9c3.31-.47 6.62-1.06 9.93-1.8v.06a740 740 0 01419.35 29.28 53.8 53.8 0 0061.26-83.62z","fill":"#f3f3f5","data-name":"Layer 1"})));
}

BgSection5.defaultProps = {"viewBox":"0 0 502.08 485.86"};

module.exports = BgSection5;

BgSection5.default = BgSection5;
